// src/hooks/useFriendActions.js
import { useState, useEffect } from "react";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { useFetchUserData } from "./useFetchUserData";
import { HandleUnfriend } from "../../UserProfile/ActiveConnections";
import {
  HandleAcceptConnectionReq,
  HandleRejectConnectionReq,
} from "../../UserProfile/ConnectionRequest";
import SendFriendRequest from "../../UserProfile/SendConnectionRequest";
import handlefollowUser from "./followUser";
import { toast } from "react-toastify";
import { toastOptions } from "../../lib/toastOptions";
import { db } from "../../FirebaseConfig";

export function useFriendActions(user) {
  const [requestList, setRequestList] = useState([]);
  const [pendingList, setPendingList] = useState([]);
  const [activeList, setActiveList] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (user) {
      // Fetch user's connections from the subcollection
      const fetchConnections = async () => {
        try {
          const connectionsRef = collection(
            db,
            "users",
            user?.uid,
            "connections"
          );
          const connectionsSnapshot = await getDocs(connectionsRef);

          const activeConnections = [];
          const requestConnections = [];
          const pendingConnections = [];

          connectionsSnapshot.forEach((doc) => {
            const connectionData = doc.data();
            if (connectionData.type === "active") {
              activeConnections.push(doc.id);
            } else if (connectionData.type === "request") {
              requestConnections.push(doc.id);
            } else if (connectionData.type === "pending") {
              pendingConnections.push(doc.id);
            }
          });

          setActiveList(activeConnections);
          setRequestList(requestConnections);
          setPendingList(pendingConnections);
        } catch (error) {
          console.error("Error fetching connections:", error.message);
        }
      };

      fetchConnections();
    }
  }, [user?.uid]);
  // console.log("activeList from useFriendAction ", activeList);
  // console.log("pendingList from useFriendAction ", pendingList);
  // console.log("requestList from useFriendAction ", requestList);
  // console.log("searchUser from useFriendAction ", searchUser);

  const handleFriendAction = async (friendUid, user) => {
    try {
      if (activeList.includes(friendUid)) {
        setLoading(true);
        await HandleUnfriend(user.uid, friendUid);
        setActiveList(activeList.filter((id) => id !== friendUid));
        toast.success("User unfriended successfully", toastOptions);
        setLoading(false);
      } else if (requestList.includes(friendUid)) {
        setLoading(true);
        await HandleRejectConnectionReq(user.uid, friendUid);
        setRequestList(requestList.filter((id) => id !== friendUid));
        toast.success("Friend request rejected successfully", toastOptions);
        setLoading(false);
      } else if (pendingList.includes(friendUid)) {
        setLoading(true);
        await HandleAcceptConnectionReq(friendUid,user?.uid,);
        setPendingList(pendingList.filter((id) => id !== friendUid));
        setActiveList([...activeList, friendUid]);
        toast.success("Friend request accepted", toastOptions);
        setLoading(false);
      } else {
        setLoading(true);
        await SendFriendRequest(user.uid, friendUid);
        setRequestList([...requestList, friendUid]);
        await handlefollowUser(user.uid, friendUid);
        toast.success("Friend request has been sent", toastOptions);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error handling friend action:", error.message);
    }
  };

  return {
    requestList,
    pendingList,
    activeList,
    handleFriendAction,
    loading,
  };
}
